import { SBCRewardType } from "@/api/privateRequests/sbcs/getSbcSets";
import { SBCRequirements } from "@/components/organisms/SBCs/SBC/SBCRequirements";
import { BottomSheet } from "@/design-system/BottomSheet/BottomSheet";
import { Button } from "@/design-system/Button/Button";
import { useTranslation } from "@repo/shared/i18n";
import { Trophy } from "lucide-react";
import { useState } from "react";

import { SolutionReward } from "./SolutionReward";

const Label = ({ children }: { children: string }) => (
  <span className="text-xs font-bold uppercase tracking-wide text-neutral-500">
    {children}
  </span>
);

/**
 * Phones have no rail to hang the challenge's details off, so the reward and
 * the requirements live behind the reward trophy in the action row and open as a
 * sheet. Same reward rendering and requirements list the rail uses.
 */
export const SbcSheetButton = ({
  reward,
  description,
  requirements,
}: {
  reward?: SBCRewardType;
  description?: string;
  requirements: string[];
}) => {
  const { t } = useTranslation("sbcs");
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="tertiary"
        size="small"
        icon={<Trophy />}
        aria-label={t(reward ? "set.rewardLabel" : "sbcCard.requirements")}
        onClick={() => setOpen(true)}
      />
      <BottomSheet isOpen={open} onClose={() => setOpen(false)}>
        <div className="flex flex-col gap-5 px-6 pb-6">
          {reward && (
            <SolutionReward
              reward={reward}
              description={description}
              label={<Label>{t("set.rewardLabel")}</Label>}
            />
          )}
          <div className="flex flex-col gap-3">
            <Label>{t("sbcCard.requirements")}</Label>
            <SBCRequirements requirements={requirements} />
          </div>
        </div>
      </BottomSheet>
    </>
  );
};
